module.exports = __webpack_public_path__ + "img/grid.35686dd5.svg";